module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasFooter) ? _c('tfoot', {
    staticClass: "p-datatable-tfoot"
  }, [(!_vm.columnGroup) ? _c('tr', _vm._l((_vm.columns), function(col, i) {
    return _c('td', {
      key: col.columnKey || col.field || i,
      class: col.footerClass,
      style: (col.footerStyle),
      attrs: {
        "colspan": col.colspan,
        "rowspan": col.rowspan
      }
    }, [(col.$scopedSlots.footer) ? _c('DTColumnSlot', {
      attrs: {
        "column": col,
        "type": "footer"
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(col.footer) + "\n        ")], 1)
  }), 0) : _vm._l((_vm.columnGroup.rows), function(row, i) {
    return _c('tr', {
      key: i
    }, _vm._l((row.columns), function(col, i) {
      return _c('td', {
        key: col.columnKey || col.field || i,
        class: col.footerClass,
        style: (col.footerStyle),
        attrs: {
          "colspan": col.colspan,
          "rowspan": col.rowspan
        }
      }, [(col.$scopedSlots.footer) ? _c('DTColumnSlot', {
        attrs: {
          "column": col,
          "type": "footer"
        }
      }) : _vm._e(), _vm._v("\n                " + _vm._s(col.footer) + "\n            ")], 1)
    }), 0)
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa8d8bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/datatable/TableFooter.vue
// module id = 2159
// module chunks = 0